import { render, staticRenderFns } from "./sell_client.vue?vue&type=template&id=770403ea"
import script from "./sell_client.vue?vue&type=script&lang=js"
export * from "./sell_client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports